/** 视窗检测参数 */
export interface CheckVisibleWindowOptions {
  el: HTMLElement;
  ratio?: {
    max: number;
    min: number;
  };
  visbleChanged: (isInVisble: boolean) => void;
}

/**
 * 检测指定元素是否在可视化区域
 */
export function checkIsInVisibleWindow(options: CheckVisibleWindowOptions) {
  const { el, ratio = { max: 0.7, min: 0.3 }, visbleChanged = () => {} } = options;
  if (!window.IntersectionObserver) {
    return;
  }
  const observer = new window.IntersectionObserver(
    (entries: IntersectionObserverEntry[]) => {
      const currRatio = entries[0].intersectionRatio;
      if (currRatio > ratio.max) {
        visbleChanged(true);
      }
      if (currRatio < ratio.min) {
        visbleChanged(false);
      }
    },
    {
      threshold: [ratio.min, ratio.max],
    },
  );
  observer.observe(el);
}
